<template>
  <li :class="`locale-table-item`">
    <div class="locale-table-item-infos">

      <i v-if="hasChildren"
         :class="`mdi ${icon} locale-table-item-infos-icon`"
         @click.stop="openNode"></i>

      <v-checkbox v-model="isSelected"
                  v-if="!isAuthorizedFalse"
                  :class="`locale-table-item-infos-text ${isUndeterminate && !isSelected ? 'underteminate' : ''}`"
                  hide-details
                  @change="handleToggle"></v-checkbox>
      <i v-else
         :class="`mdi mdi-check-circle icon`"></i>

      <div class="locale-table-item-infos-label"
           @click.stop="openNode">
        <template v-if="isAparelho || isGrupoDeLocal">
          <svgicon :icon="typeIcon"
                   width="20"
                   height="20"
                   color="gray"
                   v-if="!nodeData.isAtivo"></svgicon>
        </template>
        <i v-else
           :class="`mdi ${typeIcon} icon`"></i>

        <p>{{ node.name }}</p>

        <span class="locale-table-item-infos-label-local"
              v-if="isLocal && node.cidade && node.estado">({{node.cidade}} - {{node.estado}})</span>

        <Select v-if="isPartnerCampaign && isSelected"
                data-title="Prioridade"
                v-model="establishmentWeight"
                class="establishment-priority-select"
                clearable
                :data-search="false"
                :data-items="priorityLevels"
                @input="emitPriority($event)"
                data-menu-width="200px"
                small/>
      </div>

    </div>

    <ConfirmationModal :value="pendingToogle"
                       :confirm-label="$t('message.generics.message.confirm')"
                       @confirm="confirmToggle"
                       @cancel="cancelDeselectToogle">
      <span slot="heading">
        {{$t('message.users.message.unlinkSpot')}}
      </span>
      <span>
        {{$t('message.users.message.unlinkSpotHint')}}
      </span>
    </ConfirmationModal>
  </li>
</template>

<script>
import ConfirmationModal from "@components/ConfirmationModal";
import Select from '@components/Select';
import EventBus from "@packages/event-bus";
import { cloneDeep } from "lodash";

export default {  
  props: {
    node: {
      type: Object,
    },
    advertising: {
      type: Boolean,
      default: false,
    },
    noConfirm: {
      type: Boolean,
      default: false,
    },
    isPartnerCampaign: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ConfirmationModal,
    Select
  },

  mounted() {   
    this.setData();

    this.node.children = [];

    EventBus.$on("OPEN_NODE", this.openNodeHandler);
  },

  beforeDestroy() {
    EventBus.$off("OPEN_NODE", this.openNodeHandler);
  },

  watch: {},

  data() {
    return {
      pendingToogle: false,
      nodeChildren: [],
      isOpen: false,
      nodeData: { ...this.node },
      isSelected: this.node.selected,
      isUndeterminate: false,
      establishmentWeight: this.node.weight
    };
  },

  mixins: [],

  computed: {
    isAuthorizedFalse() {
      return this.nodeData.isAuthorized === false;
    },
    typeIcon() {
      let icon = "";

      if (this.isLocal) {
        icon = "mdi-map-marker-outline";
      } else if (this.isAparelho) {
        icon = "access-point";
      } else if (this.isEstabelecimento || this.isPartnerCampaign) {
        icon = "mdi-store";
      } else if (this.isGrupoDeLocal) {
        icon = "folder-marker-outline";
      }

      return icon;
    },
    icon() {
      return this.isOpen ? "mdi-chevron-down" : "mdi-chevron-right";
    },
    isGrupoDeLocal() {
      return this.node.type === 0;
    },
    isLocal() {
      return this.node.type === 1;
    },
    isAparelho() {
      return this.node.type === 3;
    },
    isEstabelecimento() {
      return this.node.type === -1;
    },
    hasChildren() {
      return this.nodeChildren.length;
    },
    isUserAnunciante() {
      return this.$store.state.users.user.tipo === "ANUNCIANTE";
    },
    priorityLevels() {
      return [        
        {id: 1, label: this.$t('message.campaigns.message.lowPriority') },
        {id: 2, label: this.$t('message.campaigns.message.mediumPriority') },
        {id: 3, label: this.$t('message.campaigns.message.highPriority') }
      ]
    }
  },

  methods: {
    confirmToggle() {
      this.pendingToogle = false;
      this.emitToogle();
    },
    openNodeHandler(id) {
      if (id === this.node.localTreeId) {
        this.openNode();
      }
    },
    setData(newNode) {
      this.node.isOpen = this.isOpen;
      const node = newNode || this.node;
      if (Array.isArray(node.children)) {
        this.nodeChildren = cloneDeep(node.children);
      }
      this.checkIndeterminate();
    },
    isIndeterminate(children) {
      return children.some((child) => {
        return child.selected || this.isIndeterminate(child.children || []);
      });
    },
    checkIndeterminate() {
      this.isUndeterminate = this.isIndeterminate(this.nodeChildren);
    },
    async toogleLocalAssignment(event) {
      if (!this.advertising && !this.noConfirm) {
        if (event) {
          this.emitToogle();
        } else {
          this.pendingToogle = true;
        }
      } else {
        this.emitToogle();
      }
    },
    handleToggle(event) {
      if(this.isPartnerCampaign) {
        this.$emit("toogle-establishment", this.node.id);
      } else {
        this.toogleLocalAssignment(event)
      }
    },
    emitToogle() {
      this.$emit("toogle", this.node);
    },
    cancelDeselectToogle() {
      this.pendingToogle = false;
      this.isSelected = true;
    },
    setAssignmentOnChildren(item, val) {
      if (this.nodeChildren) {
        this.nodeChildren.forEach((child) => {
          child.selected = val;
        });
      }

      if (item.children) {
        item.children.forEach((child) => {
          child.selected = val;

          this.setAssignmentOnChildren(child, val);
        });
      }
    },
    async openNode() {
      const childrenVal = this.isOpen ? [] : [...cloneDeep(this.nodeChildren)];

      this.isOpen = !this.isOpen;

      this.$emit("setIsOpen", {
        id: this.node.localTreeId,
        isOpen: this.isOpen,
      });

      this.$emit("setChildren", {
        id: this.node.localTreeId,
        value: childrenVal,
      });
    },
    emitPriority(val) {   
      this.$emit("set-priority", {priority: val, establishmentId: this.node.id})
    }
  },
};
</script>

<style lang="scss" scoped>
.locale-table-item-infos {
  display: flex;
  align-items: center;
  color: #707070;

  .locale-table-item-infos-icon {
    cursor: pointer;
  }

  .locale-table-item-infos-text {
    padding: 0;

    &.underteminate {
      ::v-deep .v-input__control {
        i {
          color: #82b1ff !important;
          caret-color: #82b1ff !important;

          &::before {
            content: "\F375";
          }
        }
      }
    }
  }

  .locale-table-item-infos-label {
    display: flex;
    align-items: center;
    cursor: pointer;

    p {
      margin: 0 5px 0 0;

      user-select: none;
      font-weight: 500;
      color: #636363;

      flex-shrink: 0;
    }

    i,
    .svg-icon {
      display: flex;
      align-items: center;
      font-size: 20px;
      text-align: center;
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }

    .locale-table-item-infos-label-local {
      flex-shrink: 0;
    }

    .establishment-priority-select {
      margin-left: 30px;
    }
  }

  .v-input {
    flex: 0;
  }

  .icon {
    margin-right: 5px;
  }
}
</style>
